





























































































import Vue from 'vue';
import { UserService } from '@/services/UserService';
import { UserCreateModel, UserCopyModel, ValueType } from '@/types';
import { FormFieldValidation, ModalHelpers } from '@/mixins';
import { StandardOrganisation } from '@/types/enums';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import OrganisationSelectList from '@/components/configuration/OrganisationSelectList.vue';
import { ValidationModel } from '@/types/models/validation';
import ApiConfiguration from '@/classes/ApiConfiguration';
import { ParameterListParams } from '@/services/GeneratedApi';

export default Vue.extend({
  name: 'AddUser',
  mixins: [FormFieldValidation, ModalHelpers],
  props: {
    isCopy: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      userCreateModel: {
        organisationId: StandardOrganisation.InternalUsers,
        forceSingleSignOn: false
      } as UserCreateModel,
      isLoading: false,
      organisationProperties: {
        isRequired: true,
        name: 'Organisation',
        validationRule: 'required'
      }
    };
  },
  methods: {
    async onSubmit(this: any) {
      try {
        const isValid = await this.$validator.validate();
        if (isValid) {
          this.isLoading = true;
          if (this.isCopy) {
            this.copyUser();
          } else {
            this.createUser();
          }
        }
      } catch (error) {
        this.$log(error);
      }
    },
    createUser(this: any) {
      UserService.createUserAsync(this.userCreateModel)
        .then((response) => {
          SnotifyConfiguration.showSuccess('User added successfully.');
          this.setApplicationDirty(false);
          this.$router.push({ name: 'userManagement' });
        })
        .catch((error) => {
          this.handleError(error);
        });
    },
    copyUser(this: any) {
      const userCopyModel = this.userCreateModel as UserCopyModel;
      userCopyModel.copyUserId = this.isCopy.id;
      UserService.copyUserAsync(userCopyModel)
        .then((response) => {
          SnotifyConfiguration.showSuccess('User copied successfully.');
          this.setApplicationDirty(false);
          this.$router.push({ name: 'userManagement' });
        })
        .catch((error) => {
          this.handleError(error);
        });
    },
    handleError(error: any) {
      this.$validator.errors.remove('serverValidationErrors');
      this.$validator.errors.add({
        field: 'serverValidationErrors',
        msg: error.notification
      });
      this.isLoading = false;
    },
    async onCancel(this: any) {
      this.$router.back();
    }
  },
  computed: {
    headerText(this: any) {
      return this.isCopy ? `Copy User (copying from ${this.isCopy.name})` : 'Add User';
    },
    isInternalUser(this: any): boolean {
      return this.userCreateModel.organisationId === StandardOrganisation.InternalUsers;
    }
  },
  async created(this: any) {
    this.UsernameValidation = {
      required: true,
      valueType: ValueType.UserName,
      maxLength: 50
    } as ValidationModel;
    this.EmailValidation = {
      required: true,
      valueType: ValueType.Email,
      maxLength: 100
    } as ValidationModel;
    if (this.isCopy) {
      this.userCreateModel.organisationId = this.isCopy.organisation.id;
      this.userCreateModel.authClientId = this.isCopy.authClientId;
      this.userCreateModel.forceSingleSignOn = this.isCopy.forceSingleSignOn;
    } else {
      try {
        this.isLoading = true;
        const forceSingleSignOnParameterResult = await ApiConfiguration.api().parameter.parameterList({
          entityTypeId: 0,
          entityPk: '0',
          group: 'SingleSignOn',
          code: 'ForceSingleSignOnByDefault'
        } as ParameterListParams);
        const forceSingleSignOn = String(forceSingleSignOnParameterResult);
        this.userCreateModel.forceSingleSignOn = forceSingleSignOn.toLowerCase() === 'true' || forceSingleSignOn.toLowerCase() === '1';
      } catch (error) {
        this.$log(error);
      } finally {
        this.isLoading = false;
      }
    }
  },
  mounted() {
    UserService.checkMaintenancePermissions();
  },
  components: {
    OrganisationSelectList,
    SingleSignOnProviderList: () => import('./SingleSignOnProviderList.vue')
  }
});
